"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAR = exports.REPLACE = exports.UPDATE = void 0;
var lodash_1 = __importDefault(require("lodash"));
var UPDATE = function (entityName) { return "".concat(entityName, "/filters/UPDATE_FILTER"); };
exports.UPDATE = UPDATE;
var REPLACE = function (entityName) { return "".concat(entityName, "/filters/CLEAR_FILTER"); };
exports.REPLACE = REPLACE;
var CLEAR = function (entityName) { return "".concat(entityName, "/filters/CLEAR_FILTER"); };
exports.CLEAR = CLEAR;
var processFilters = function (entityName, state, action) {
    var _a;
    switch (action.type) {
        case (0, exports.UPDATE)(entityName):
            var _b = action.payload, sectionKey = _b.sectionKey, filterKey_1 = _b.filterKey;
            var section = state.filters[sectionKey] || {};
            var filters = lodash_1.default.reduce(section.filters, function (result, f) {
                if (f.name === filterKey_1) {
                    f.isSelected = !f.isSelected;
                    if (f.customDateFilterType === 'custom' && !f.isSelected) {
                        f.customDateRangeStart = null;
                        f.customDateRangeEnd = null;
                    }
                }
                result.push(f);
                return result;
            }, []);
            return __assign(__assign({}, state), { filters: __assign(__assign({}, state.filters), (_a = {}, _a[sectionKey] = __assign(__assign({}, section), { filters: filters }), _a)) });
        case (0, exports.REPLACE)(entityName):
            return __assign(__assign({}, state), { filters: __assign({}, action.payload) });
        case (0, exports.CLEAR)(entityName):
            return __assign(__assign({}, state), { filters: lodash_1.default.map(lodash_1.default.keys(state.filters), function (key) {
                    var filterCategory = state.filters[key];
                    return __assign(__assign({}, filterCategory), { filters: lodash_1.default.map(filterCategory.filters, function (f) { return (__assign(__assign({}, f), { value: false })); }) });
                }) });
        default:
            return state;
    }
};
exports.default = { processFilters: processFilters };
//# sourceMappingURL=filters.reducers-enhancer.js.map